module.exports = __webpack_public_path__ + "static/media/Serpent_stew.4d797531.png";